import React, { Component } from "react";
import { Buffer } from "buffer";
import Button from "@material-ui/core/Button";
import ClearIcon from "@mui/icons-material/Clear";
import FileViewer from "react-file-viewer";
import CancelIcon from "@mui/icons-material/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  GetCampaigningInfo_Url,
  MessageTemplateList_Url,
  UpdateCampaigningInfo_Url,
  UploadCampaigningInfoFile_Url,
} from "../../../provider/ServiceUrl";
import { ValidatorForm } from "react-material-ui-form-validator";
import Utils from "../../../provider/Utils";
import CancelIconButton from "../buttons/CancelIconButton";
import SaveButton from "../buttons/SaveButton";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import PtsAlert from "../ptsAlert/PtsAlert";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
class UsecaseDialog extends Component {
  header = store.getState().header.header;
  messageTypeList = store.getState().staticData.messageTypeList;
  optinCollectionOptionList =
    store.getState().staticData.optinCollectionOptionList;
  optinPermissonMethodList =
    store.getState().staticData.optinPermissonMethodList;
  sendMessageTypeList = store.getState().staticData.sendMessageTypeList;

  constructor(props) {
    super(props);
    this.state = {
      sendTextCanada: "",
      campaignDescription: "",
      keyword: "",
      usecaseText: "",
      sampleText1: "",
      sampleText2: "",
      optInPermissionMethod: [],
      textPerMonth: "",
      sendMessageType: Utils.getArrayElement(this.messageTypeList, 0),
      messageTemplate1: null,
      messageTemplate2: null,
      messageType: null,
      optionPermissionLink: "",
      showLinkTextFile: false,
      showFileView: false,
      optInPermissionMethodList: [],
      messageTemplateList: [],
      messageTemplateListAll: [],
      selectedFile: "",
      fileName: "",
      twilioNumber: null,
      isEmailRequest: false,
      isOnlineForm: false,
      onlineFormUrl: null,
      isOnlineCheckout: false,
      onlineCheckoutUrl: null,
      emailDocUrl: null,
      useCaseTemplate: null,
      keywordDocUrl: null,
      isTextKeyword: false,
      render: false,
      open: false,
    };
  }

  handleOpen() {
    this.getMessageTemplateList();
    this.getCampaignDetails();
    this.adjustTextareaHeight();
    this.adjustTextarea1Height();
    this.adjustTextarea2Height();
  }

  handleUseCaseClose() {
    this.setState({ open: false });
  }

  getMessageTemplateList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(MessageTemplateList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let messageTemplateList = output.data.messageTemplateList;
          let useCaseList = output.data.useCaseList;
          const sampleMessageTemplate = {
            messageName: "I will enter my own sample below.",
            textMessage: "",
            id: "sample_default",
          };
          const updatedMessageTemplateList = [
            sampleMessageTemplate,
            ...messageTemplateList,
          ];
          this.setState({
            messageTemplateList: updatedMessageTemplateList,
            messageTemplateListAll: updatedMessageTemplateList,
            messageTemplate1: updatedMessageTemplateList[0],
            messageTemplate2: updatedMessageTemplateList[0],
            useCaseList: useCaseList,
          });
        } else {
        }
      }
    );
  }

  getCampaignDetails() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(GetCampaigningInfo_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let campaigningInfoDetails = output.data.campaigningInfo;
          let businessUseCaseDetails = output.data.businessUseCase;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          if (campaigningInfoDetails?.graphicDocuments) {
            const {
              emailDocument,
              emailFileext,
              emailFilename,
              keywordDocument,
              keywordFileext,
              keywordFilename,
            } = campaigningInfoDetails.graphicDocuments;

            const emailUrl = emailDocument
              ? Utils.base64ToUrl(emailDocument)
              : null;
            const keywordUrl = keywordDocument
              ? Utils.base64ToUrl(keywordDocument)
              : null;
            this.setState({
              emailDocUrl: emailUrl,
              emailDocType: emailFileext?.split(".")?.pop(),
              emailDocument: emailDocument,
              emailFilename: emailFilename,
              keywordDocUrl: keywordUrl,
              keywordDocType: keywordFileext?.split(".")?.pop(),
              keywordDocument: keywordDocument,
              keywordFilename: keywordFilename,
              documentId: campaigningInfoDetails?.graphicDocuments?.id,
              open: true,
              showFileView: true,
              showLinkTextFile: false,
            });
          }
          let textToCanada = "";
          if (campaigningInfoDetails.texttocanada === true) {
            textToCanada = "Yes";
          } else {
            textToCanada = "No";
          }

          const selectedUseCase = this.state.useCaseList.find(
            (item) => item?.usecaseName === campaigningInfoDetails?.usecase
          );

          this.setState({
            render: true,
            open: true,
            action:
              campaigningInfoDetails.messageType !== null ? "view" : "edit",
            viewTwilioNumber: true,
            addTwilioNumber: false,
            id: campaigningInfoDetails.id,
            useCaseTemplate: selectedUseCase,
            usecase: campaigningInfoDetails.usecase,
            usecaseText: campaigningInfoDetails.description,
            sampleText1: campaigningInfoDetails.sampletext1,
            sampleText2: campaigningInfoDetails.sampletext2,
            textPerMonth:
              campaigningInfoDetails.textpermonth !== null
                ? campaigningInfoDetails.textpermonth
                : 1000,
            sendTextCanada:
              campaigningInfoDetails.texttocanada !== null
                ? campaigningInfoDetails.texttocanada
                : false,
            optionPermissionLink: campaigningInfoDetails.optinpermissionlink,
            messageType: campaigningInfoDetails.sendMessageType,
            sendMessageType:
              campaigningInfoDetails.messageType !== null
                ? campaigningInfoDetails.messageType
                : Utils.getArrayElement(this.messageTypeList, 0),
            keyword: campaigningInfoDetails.keyword,
            viewSendTextCanad: textToCanada,
            // selectedFile: campaigningInfoDetails?.filename,
            // optInCollectionFromAudience:
            //   campaigningInfoDetails.optinCollectionOption,
            // fileOptionLanguage: campaigningInfoDetails.fileOptinlanguage,
            // viewOptInPermissionMethod: campaigningInfoDetails?.optinPermissions,
            // tollfreeRequestSubmitted:
            //   campaigningInfoDetails.tollfreeRequestSubmitted,
            twilioNumber: campaigningInfoDetails.twilioNumber,
            businessUseCase: businessUseCaseDetails,
            // optInPermissionMethod: optInPermissionMethodList,
            // optInPermissionMethodList: optInPermissionMethodListId,
            getUpdatePermission: getUpdatePermission,
          });
        } else {
        }
      }
    );
  }

  handleCampaignDescriptionChange(e) {
    this.setState({ campaignDescription: e.target.value });
  }

  handleSendMessageTypeChange(selectedType) {
    this.state.sendMessageType = selectedType;
    this.setState({
      sendMessageType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleMessageTemplate1Change(selectedMessage) {
    let messageTemplates = [];
    for (let i = 0; i < this.state.messageTemplateListAll.length; i++) {
      const messageTemplate = this.state.messageTemplateListAll[i];
      if (
        messageTemplate.messageName !== selectedMessage.messageName ||
        messageTemplate.messageName === "Custom"
      ) {
        messageTemplates.push(messageTemplate);
      }
    }
    this.setState({
      render: true,
      messageTemplate1: selectedMessage,
      sampleText1: selectedMessage?.textMessage,
      messageTemplateList: messageTemplates,
    });
  }
  handleMessageTemplate2Change(selectedMessage) {
    let messageTemplates = [];
    for (let i = 0; i < this.state.messageTemplateListAll.length; i++) {
      const messageTemplate = this.state.messageTemplateListAll[i];
      if (
        messageTemplate.messageName !== selectedMessage.messageName ||
        messageTemplate.messageName === "Custom"
      ) {
        messageTemplates.push(messageTemplate);
      }
    }
    this.setState({
      messageTemplate2: selectedMessage,
      sampleText2: selectedMessage?.textMessage,
      messageTemplateList: messageTemplates,
    });
  }

  handleOptInPermissionMethodChange(selectedType) {
    this.state.optInPermissionMethod = selectedType;
    let optInPermissionMethodList = [];
    for (let i = 0; i < selectedType.length; i++) {
      optInPermissionMethodList.push(selectedType[i].id);
    }
    this.setState({
      optInPermissionMethod: selectedType,
      optInPermissionMethodList: optInPermissionMethodList,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleMessageTypeListChange(selectedType) {
    this.state.messageType = selectedType;
    this.setState({
      messageType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleTextPerMonthChange(e) {
    const { value } = e.target;
    this.setState({ textPerMonth: value });
  }
  handleSampleText1Change(e) {
    const { value } = e.target;
    this.setState({ sampleText1: value });
  }
  handleSampleText2Change(e) {
    const { value } = e.target;
    this.setState({ sampleText2: value });
  }
  handleSendTextCanadaChange(e) {
    const { value } = e.target;
    this.setState({ sendTextCanada: value });
  }

  handleOptionPermissionLinkChange(e) {
    this.setState({ optionPermissionLink: e.target.value });
  }
  handleOptInCollectionFromAudienceChange(selectedType) {
    this.state.optInCollectionFromAudience = selectedType;
    if (undefined === this.state.onChange) {
      this.setState({ showLinkTextFile: false, showFileView: false });
    }
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    if (
      Utils.equalsIgnoreCase(
        selectedType?.name,
        "Insert a link to the online form that collects opt-in permission."
      )
    ) {
      this.setState({
        optInCollectionFromAudience: selectedType,
        showLinkTextFile: true,
        showFileView: false,
      });
    } else if (
      Utils.equalsIgnoreCase(
        selectedType?.name,
        "Upload a copy of a sign or graphic that shows your opt-in language"
      )
    ) {
      this.setState({
        optInCollectionFromAudience: selectedType,
        showLinkTextFile: false,
        showFileView: true,
      });
    }
  }


  handleUseCaseTemplateChange(selectedUseCase) {
    this.setState(
      {
        useCaseTemplate: selectedUseCase,
        usecase: selectedUseCase?.usecaseName,
        usecaseText: selectedUseCase?.usecaseText
      },
      () => {
        this.adjustTextareaHeight();
      }
    );
  }

  handleUsecaseTextChange(e) {
    this.setState(
      { usecaseText: e.target.value },
      () => {
        this.adjustTextareaHeight();
      }
    );
  }

  componentDidMount() {
    this.adjustTextareaHeight();
    this.adjustTextarea1Height();
    this.adjustTextarea2Height();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.usecaseText !== this.state.usecaseText) {
      this.adjustTextareaHeight();
    }
    if (prevState.sampleText1 !== this.state.sampleText1) {
      this.adjustTextarea1Height();
    }
    if (prevState.sampleText2 !== this.state.sampleText2) {
      this.adjustTextarea2Height();
    }
  }


  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  adjustTextarea1Height = () => {
    if (this.textareaRef1.current) {
      this.textareaRef1.current.style.height = "auto";
      this.textareaRef1.current.style.height =
        this.textareaRef1.current.scrollHeight + "px";
    }
  };
  adjustTextarea2Height = () => {
    if (this.textareaRef2.current) {
      this.textareaRef2.current.style.height = "auto";
      this.textareaRef2.current.style.height =
        this.textareaRef2.current.scrollHeight + "px";
    }
  };

  updateCampaignDetailsInBackend() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        usecase: this.state.usecase,
        description: this.state.usecaseText,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,

        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,

        // optinPermissionMethodList: this.state.optInPermissionMethodList,
        // optinCollectionOption: {
        //   id: this.state.optInCollectionFromAudience.id,
        // },
      },
    };
    FetchServerData.callPostService(UpdateCampaigningInfo_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ render: true, open: false });
        } else {
        }
      })
      .catch((error) => { });
  }

  submitCampaignInfoInBackend() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        usecase: this.state.usecase,
        description: this.state.usecaseText,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,
        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,
      },
    };
    FetchServerData.callPostService("/campaigningInfoms/submit", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ render: true, open: false });
          store.dispatch(AppUserDataAction.setTollfreeNumberPurchased(true));
        } else {
        }
      })
      .catch((error) => { });
  }

  optinFileHandler(e) {
    let file = e.target.files[0];
    let reader = new FileReader();
    this.setState({
      selectedFile: e.target.files[0],
      responseArray: [],
    });
    reader.onload = (e) => {
      let file = e.target.result;
      let file1 = file.split(",");
      this.setFile = file1[1];

      const formData = new FormData();

      formData.append(
        "file",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      formData.append("sessionid", this.header.sessionid);
      formData.append("userid", this.header.userid);
      formData.append("adid", this.props.advertisementId);
      formData.append("isAp", this.header.isAp);
      formData.append("appclient", "W");

      this.setState({ fileOptionLanguage: this.setFile });
    };
    reader.readAsDataURL(file);
  }

  onLogoChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.setState(
      {
        selectedFile: file,
      },
      () => this.uploadOptInFile()
    );
  }

  uploadOptInFile(e) {
    if (!this.state.selectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(
      UploadCampaigningInfoFile_Url,
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadFileDetails = output.data;
        const byteArray = new Buffer(
          uploadFileDetails?.fileOptinlanguage.replace(/^.+base64,/, ""),
          "base64"
        );
        const url = URL.createObjectURL(new Blob([byteArray]));

        let fileName = uploadFileDetails?.filename;
        let urlArr = fileName.split(".");
        let fileType = urlArr[1];
        this.setState({
          newUrl: url,
          fileType: fileType,
          fileOptionLanguage: uploadFileDetails.fileOptinlanguage,
          fileName: uploadFileDetails?.filename,
          open: true,
        });

        PtsAlert.success(output.message);
      } else {
      }
    });
  }

  resetFile() {
    document.getElementsByName("file")[0].value = null;
  }

  handleEmailRequestChange(e) {
    this.setState({ isEmailRequest: e.target.checked });
  }
  handleIsTextKeywordChange(e) {
    this.setState({ isTextKeyword: e.target.checked });
  }
  handleKeyWordChange(e) {
    const { value } = e.target;
    this.setState({ keyword: value });
  }

  handleIsOnlineFormChange(e) {
    this.setState({ isOnlineForm: e.target.checked });
  }
  handleOnlineFormUrlChange(e) {
    this.setState({ onlineFormUrl: e.target.value });
  }
  handleIsOnlineCheckoutChange(e) {
    this.setState({ isOnlineCheckout: e.target.checked });
  }
  handleOnlineCheckoutUrlChange(e) {
    this.setState({ onlineCheckoutUrl: e.target.value });
  }

  deleteOptinLangFile() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        id: this.state.id,
      },
    };
    FetchServerData.callPostService(
      "/campaigningInfoms/deleteOptinLangFile",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          newUrl: null,
          selectedFile: { name: "" },
          fileType: "",
          fileName: "",
          fileOptinlanguage: "",
        });
      } else {
      }
    });
  }

  onUploadEmailScreenshotDoc(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.setState(
      {
        selectedFile: file,
      },
      () => this.uploadEmailScreenshotDoc()
    );
  }

  uploadEmailScreenshotDoc(e) {
    if (!this.state.selectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(
      "/campaigningInfoms/uploadEmailScreenshotDoc",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadEmailDocument = output.data;
        const byteArray = new Buffer(
          uploadEmailDocument?.emailDocument?.replace(/^.+base64,/, ""),
          "base64"
        );
        const url = URL.createObjectURL(new Blob([byteArray]));

        let emailFilename = uploadEmailDocument?.emailFilename;
        let urlArr = emailFilename.split(".");
        let emailDocType = urlArr[1];
        this.setState({
          emailDocUrl: url,
          emailDocType: emailDocType,
          emailDocument: uploadEmailDocument.emailDocument,
          emailFilename: emailFilename,
          documentId: uploadEmailDocument.id,
          open: true,
        });

        PtsAlert.success(output.message);
        // this.resetFile();
      } else {
      }
    });
  }

  onUploadKeywordScreenshotDoc(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.setState(
      {
        keywordSelectedFile: file,
      },
      () => this.uploadKeywordScreenshotDoc()
    );
  }

  uploadKeywordScreenshotDoc(e) {
    if (!this.state.keywordSelectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    formData.append(
      "file",
      this.state.keywordSelectedFile,
      this.state.keywordSelectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(
      "/campaigningInfoms/uploadKeywordScreenshotDoc",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadKeywordDocument = output.data;
        const byteArray = new Buffer(
          uploadKeywordDocument?.keywordDocument?.replace(/^.+base64,/, ""),
          "base64"
        );
        const url = URL.createObjectURL(new Blob([byteArray]));

        let keywordFilename = uploadKeywordDocument?.keywordFilename;
        let urlArr = keywordFilename.split(".");
        let keywordDocType = urlArr[1];
        this.setState({
          keywordDocUrl: url,
          keywordDocType: keywordDocType,
          keywordDocument: uploadKeywordDocument.keywordDocument,
          keywordFilename: keywordFilename,
          documentId: uploadKeywordDocument.id,
          open: true,
        });

        PtsAlert.success(output.message);
        // this.resetFile();
      } else {
      }
    });
  }

  deleteKeywordScreenshotDoc() {
    const postObject = {
      header: this.header,
      documentId: this.state.documentId,
    };
    FetchServerData.callPostService(
      "/campaigningInfoms/deleteKeywordScreenshotDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          keywordDocUrl: null,
          keywordSelectedFile: { name: "" },
          keywordDocType: "",
          keywordFilename: "",
          keywordDocument: "",
          keywordDocumentId: "",
        });
      } else {
      }
    });
  }

  deleteEmailScreenshotDoc() {
    const postObject = {
      header: this.header,
      documentId: this.state.documentId,
    };
    FetchServerData.callPostService(
      "/campaigningInfoms/deleteEmailScreenshotDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          emailDocUrl: null,
          emailSelectedFile: { name: "" },
          emailDocType: "",
          emailFilename: "",
          emailDocument: "",
        });
      } else {
      }
    });
  }
  showEmailDocument = () => {
    return (
      <Dialog
        open={this.state.showEmailDoc}
        onClose={this.handleClose.bind(this)}
        maxWidth="xxl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Email Document</span>
        </DialogTitle>
        <DialogContent style={{ minHeight: "500px" }}>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            {this.state.emailDocType === "txt" ? (
              <iframe
                src={this.state.emailDocUrl}
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.emailDocType}
                  filePath={this.state.emailDocUrl}
                  onError={this.onError}
                  height={800}
                />
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            size="small"
            style={{
              background: "#717373",
              color: "#fff",
              marginRight: "1rem",
            }}
            onClick={this.handleClose.bind(this)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  showKeywordDocument = () => {
    return (
      <Dialog
        open={this.state.showKeywordDoc}
        onClose={this.handleClose.bind(this)}
        maxWidth="xxl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Keyword Document</span>
        </DialogTitle>
        <DialogContent style={{ minHeight: "500px" }}>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            {this.state.keywordDocType === "txt" ? (
              <iframe
                src={this.state.keywordDocUrl}
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.keywordDocType}
                  filePath={this.state.keywordDocUrl}
                  onError={this.onError}
                  height={800}
                />
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            size="small"
            style={{
              background: "#717373",
              color: "#fff",
              marginRight: "1rem",
            }}
            onClick={this.handleClose.bind(this)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  onClickShowEmailDoc() {
    this.setState({ showEmailDoc: true });
  }
  onClickShowKeywordDoc() {
    this.setState({ showKeywordDoc: true });
  }
  handleClose() {
    this.setState({ showEmailDoc: false, showKeywordDoc: false });
  }

  render() {
    this.textareaRef = React.createRef();
    this.textareaRef1 = React.createRef();
    this.textareaRef2 = React.createRef();

    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleUseCaseClose.bind(this)}
          // onHide={this.close}
          style={{ padding: "1em" }}
          className="usecaseDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <div className="row d-flex">
              <div className="col-sm-12" style={{ color: "#fff" }}>
                Your new texting number needs to be verified.
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <>
              <ValidatorForm
                ref="form"
                id="multiStepsForm"
                onSubmit={this.updateCampaignDetailsInBackend.bind(this)}
              >
                <div id="useCaseDetailsValidation" className="row">
                  <div className="col-md-12">
                    <div
                      className="card "
                      id="giveBeeCardTopBoxShadowremove"
                      style={{ borderRadius: "0rem 0.5rem 0.5rem 0.5rem" }}
                    >
                      <div
                        className="card-header d-flex align-items-center justify-content-between p-2"
                        id="assetCardHeader"
                      >
                        <h6 className="mb-0" id="headerLabel">
                          These are the details used to verify your texting number.
                        </h6>
                      </div>
                      <div className="card-body p-2">
                        <div className="col-md-12 ">
                          <div className="row">
                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                              Before you can start sending text messages, AT&T and
                              Verizon require some details about your use case and
                              opt-in process. Once they’ve reviewed your answers,
                              your new phone number will be verified for texting.
                            </p>
                            <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                              <b>
                                Please submit this form as soon as possible to start
                                the approval process.
                              </b>
                            </p>
                          </div>
                          <hr></hr>
                          <div className="row">
                            <div className="col-sm-4">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Which of these best represents your message type?*
                              </label>
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.sendMessageTypeList}
                                value={this.state.messageType}
                                getOptionLabel={(option) => option.description}
                                defaultValue={this.state.messageType}
                                onChange={(event, value) => {
                                  this.handleMessageTypeListChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    required
                                    title=""
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-4">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Max number of text you'll likely send in a month.*
                              </label>
                              <select
                                title=""
                                required
                                id="multiStepsState"
                                className="select2 form-select"
                                style={{ width: "120px" }}
                                data-allow-clear="true"
                                value={this.state.textPerMonth}
                                onChange={this.handleTextPerMonthChange.bind(this)}
                              >
                                <option value="">Select</option>
                                <option value="10">10</option>
                                <option value="100">100</option>
                                <option value="1000">1,000</option>
                                <option value="3000">3,000</option>
                                <option value="10000">10,000</option>
                              </select>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-sm-4">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Which of these best represents your use case?*
                              </label>

                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.messageTypeList}
                                value={this.state.sendMessageType}
                                getOptionLabel={(option) => option.type}
                                defaultValue={this.state.sendMessageType}
                                onChange={(event, value) => {
                                  this.handleSendMessageTypeChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    required
                                    title=""
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-4">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Will you be texting people in Canada?*
                              </label>
                              <select
                                title=""
                                required
                                id="multiStepsState"
                                className="select2 form-select"
                                style={{ width: "120px" }}
                                data-allow-clear="true"
                                value={this.state.sendTextCanada}
                                onChange={this.handleSendTextCanadaChange.bind(
                                  this
                                )}
                              >
                                <option value="">Select</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-sm-4">
                              <div className="row">
                                <div className="col-sm-12">
                                  {" "}
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Use case
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.useCaseList}
                                    value={this.state.useCaseTemplate}
                                    getOptionLabel={(option) => option.usecaseName}
                                    defaultValue={this.state.useCaseTemplate}
                                    onChange={(event, value) => {
                                      this.handleUseCaseTemplateChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="textField"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-sm-12 mt-2">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Use case Description*
                                  </label>
                                  <textarea
                                    ref={this.textareaRef}
                                    title=""
                                    required
                                    value={this.state.usecaseText}
                                    onChange={this.handleUsecaseTextChange.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    // rows="3"
                                    style={{
                                      overflow: "hidden",
                                      resize: "vertical",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-sm-4">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Use case description
                                      </label>
                                      <textarea
                                        title=""
                                        required
                                        autoFocus={true}
                                        value={this.state.campaignDescription}
                                        onChange={this.handleCampaignDescriptionChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="6"
                                        style={{
                                          overflow: "hidden",
                                          resize: "vertical",
                                        }}
                                      />
                                    </div> */}
                          </div>
                          <div className="row mt-2">
                            <div className="col-sm-4">
                              <div className="row">
                                <div className="col-sm-12">
                                  {" "}
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Sample text message Template 1
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.messageTemplateList}
                                    value={this.state.messageTemplate1}
                                    getOptionLabel={(option) => option.messageName}
                                    defaultValue={this.state.messageTemplate1}
                                    onChange={(event, value) => {
                                      this.handleMessageTemplate1Change(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="I will enter my own sample below"
                                        variant="outlined"
                                        size="small"
                                        className="textField"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-sm-12 mt-2">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Sample text message 1*
                                  </label>
                                  <textarea
                                    ref={this.textareaRef1}
                                    title=""
                                    required
                                    value={this.state.sampleText1}
                                    onChange={this.handleSampleText1Change.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    // rows="3"
                                    style={{
                                      overflow: "hidden",
                                      resize: "vertical",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="row">
                                <div className="col-sm-12">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Sample text message Template 2
                                    {/* <InfoTooltip
                                              data="Select from predefined templates."
                                              style={{
                                                float: "right",
                                              }}
                                            /> */}
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.messageTemplateList}
                                    value={this.state.messageTemplate2}
                                    getOptionLabel={(option) => option.messageName}
                                    defaultValue={this.state.messageTemplate2}
                                    onChange={(event, value) => {
                                      this.handleMessageTemplate2Change(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="I will enter my own sample below"
                                        variant="outlined"
                                        size="small"
                                        className="textField"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-sm-12 mt-2">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                  >
                                    Sample text message 2*
                                  </label>
                                  <textarea
                                    ref={this.textareaRef2}
                                    title=""
                                    required
                                    value={this.state.sampleText2}
                                    onChange={this.handleSampleText2Change.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    // rows="3"
                                    style={{
                                      overflow: "hidden",
                                      resize: "vertical",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-sm-6 mt-3">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Which of these methods will you use to collect
                                opt-in?
                              </label>
                              <div
                                className="d-flex align-items-center mt-2"
                                id="assetFormLabel"
                              >
                                <div className="col-sm-3 pe-0" style={{ width: "195px" }}>
                                  <span
                                    className="me-1"
                                    style={{ marginTop: "1px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      id="emailrequest-checkbox"
                                      value={this.state.isEmailRequest}
                                      onChange={(e) =>
                                        this.handleEmailRequestChange(e)
                                      }
                                      checked={this.state.isEmailRequest}
                                    />
                                  </span>

                                  <label
                                    className="form-label"
                                    htmlFor="emailrequest-checkbox"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Email request
                                  </label>
                                </div>
                                <div className="col-sm-6 ps-2">
                                  {/* {this.state.emailDocUrl !== null ? (
                                            <>
                                              <span
                                                onClick={(e) => this.onClickShowEmailDoc()}
                                                className="anchortag"
                                              >
                                                View Email doc
                                              </span>
                                              <span className="ms-2">
                                                <ClearIcon
                                                  className="logoDelete"
                                                  style={{
                                                    cursor: "pointer",
                                                    borderRadius: "50%",
                                                    border: "solid 2px",
                                                    color: "#697a8d",
                                                  }}
                                                  onClick={this.deleteEmailScreenshotDoc.bind(
                                                    this
                                                  )}
                                                />
                                              </span>
                                            </>
                                          ) : (
                                            <span className="csvFile align-self-center">
                                              <label
                                                htmlFor="email-upload"
                                                class="custom-file-upload"
                                              >
                                                Upload Email Screenshot
                                              </label>
                                              <input
                                                id="email-upload"
                                                type="file"
                                                name="file"
                                                accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                                                style={{ margin: "0.2em" }}
                                                ref={this.emailDocUploadRef}
                                                onChange={this.onUploadEmailScreenshotDoc.bind(
                                                  this
                                                )}
                                                onClick={(e) => {
                                                  e.target.value = null;
                                                  this.setState({
                                                    imageError: "",
                                                    selectedFile: { name: "" },
                                                  });
                                                }}
                                              />
                                            </span>
                                          )} */}
                                </div>
                              </div>
                              <div
                                className="row d-flex align-items-center mt-2"
                                id="assetFormLabel"
                              >
                                <div className="col-sm-3 pe-0" style={{ width: "195px" }}>
                                  <span
                                    className="me-1"
                                    style={{ marginTop: "1px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      id="onlineform-checkbox"
                                      value={this.state.isOnlineForm}
                                      onChange={(e) =>
                                        this.handleIsOnlineFormChange(e)
                                      }
                                      checked={this.state.isOnlineForm}
                                    />
                                  </span>
                                  <label
                                    className="form-label"
                                    htmlFor="onlineform-checkbox"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Online form URL
                                  </label>
                                </div>
                                <div className="col-sm-6">
                                  <input
                                    title=""
                                    required={this.state.isOnlineForm === true}
                                    value={this.state.onlineFormUrl}
                                    onChange={this.handleOnlineFormUrlChange.bind(
                                      this
                                    )}
                                    type="text"
                                    id="multiStepsCity"
                                    className="form-control"
                                    placeholder="Insert link to form that collects opt-in"
                                  />
                                </div>
                              </div>
                              <div
                                className="row d-flex align-items-center mt-2"
                                id="assetFormLabel"
                              >
                                <div className="col-sm-3 pe-0" style={{ width: "195px" }}>
                                  <span
                                    className="me-1"
                                    style={{ marginTop: "1px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      id="onlinecheckout-checkbox"
                                      value={this.state.isOnlineCheckout}
                                      onChange={(e) =>
                                        this.handleIsOnlineCheckoutChange(e)
                                      }
                                      checked={this.state.isOnlineCheckout}
                                    />
                                  </span>

                                  <label
                                    className="form-label"
                                    htmlFor="onlinecheckout-checkbox"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Online Checkout URL
                                  </label>
                                </div>

                                <div className="col-sm-6">
                                  <input
                                    title=""
                                    required={this.state.isOnlineCheckout === true}
                                    value={this.state.onlineCheckoutUrl}
                                    onChange={this.handleOnlineCheckoutUrlChange.bind(
                                      this
                                    )}
                                    type="text"
                                    id="multiStepsCity"
                                    className="form-control"
                                    placeholder="Insert link to form that collects opt-in"
                                  />
                                </div>
                              </div>
                              <div
                                className="row d-flex align-items-center mt-2"
                                id="assetFormLabel"
                              >
                                <div className="col-sm-3 pe-0" style={{ width: "195px" }}>
                                  <span
                                    className="me-1"
                                    style={{ marginTop: "1px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      id="textakeyword-checkbox"
                                      value={this.state.isTextKeyword}
                                      onChange={(e) =>
                                        this.handleIsTextKeywordChange(e)
                                      }
                                      checked={this.state.isTextKeyword}
                                    />
                                  </span>

                                  <label
                                    className="form-label"
                                    htmlFor="textakeyword-checkbox"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Text a keyword
                                  </label>
                                </div>
                                <div className="col-sm-6">
                                  <input
                                    title=""
                                    required={this.state.isTextKeyword === true}
                                    value={this.state.keyword}
                                    onChange={this.handleKeyWordChange.bind(this)}
                                    type="text"
                                    id="multiStepsCity"
                                    className="form-control"
                                    placeholder="Enter a keyword you will likely use"
                                  />
                                </div>
                                <div className="col-sm-5">
                                  {/* {this.state.keywordDocUrl !== null ? (
                                            <>
                                              <span
                                                onClick={(e) =>
                                                  this.onClickShowKeywordDoc()
                                                }
                                                className="anchortag"
                                              >
                                                View Keyword doc
                                              </span>
                                              <span className="ms-2">
                                                <ClearIcon
                                                  className="logoDelete"
                                                  style={{
                                                    cursor: "pointer",
                                                    borderRadius: "50%",
                                                    border: "solid 2px",
                                                    color: "#697a8d",
                                                  }}
                                                  onClick={this.deleteKeywordScreenshotDoc.bind(
                                                    this
                                                  )}
                                                />
                                              </span>
                                            </>
                                          ) : (
                                            <span className="csvFile align-self-center">
                                              <label
                                                htmlFor="keyword-upload"
                                                class="custom-file-upload"
                                              >
                                                Upload Keyword Screenshot
                                              </label>
                                              <input
                                                id="keyword-upload"
                                                type="file"
                                                name="file"
                                                accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                                                style={{ margin: "0.2em" }}
                                                ref={this.keywordDocUploadRef}
                                                onChange={this.onUploadKeywordScreenshotDoc.bind(
                                                  this
                                                )}
                                                onClick={(e) => {
                                                  e.target.value = null;
                                                  this.setState({
                                                    imageError: "",
                                                    keywordSelectedFile: { name: "" },
                                                  });
                                                }}
                                              />
                                            </span>
                                          )} */}
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-sm-4 mt-3">
                                      <div className="row">
                                        <label
                                          htmlFor="exampleFormControlTextarea1"
                                          className="form-label mb-3"
                                        >
                                          Opt-in language sign/graphic
                                        </label>
                                        {!this.state.emailDocUrl && (
                                          <span className="csvFile align-self-center">
                                            <label
                                              htmlFor="file-upload"
                                              class="custom-file-upload"
                                            >
                                              Upload Email Screenshot
                                            </label>
                                            <input
                                              id="file-upload"
                                              type="file"
                                              name="file"
                                              inputlabelprops={{
                                                shrink: true,
                                                style: {},
                                              }}
                                              style={{ margin: "0.2em" }}
                                              ref={this.fileUploadRef}
                                              onChange={this.onUploadEmailScreenshotDoc.bind(
                                                this
                                              )}
                                              onClick={(e) => {
                                                e.target.value = null;
                                                this.setState({
                                                  imageError: "",
                                                  selectedFile: { name: "" },
                                                });
                                              }}
                                            />
                                          </span>
                                        )}
                                        {this.state.emailDocUrl && (
                                          <>
                                            <div className="col-sm-8 pe-0 d-flex">
                                              <img
                                                style={{
                                                  // width: "-webkit-fill-available",
                                                  height: "10em",
                                                  objectFit: "contain",
                                                  objectPosition: "left",
                                                }}
                                                alt=""
                                                src={
                                                  this.state.emailDocUrl
                                                    ? this.state.emailDocUrl
                                                    : ""
                                                }
                                              />
                                              <span className="fw-bold ms-2">
                                                <ClearIcon
                                                  className="logoDelete"
                                                  style={{
                                                    cursor: "pointer",
                                                    borderRadius: "50%",
                                                    border: "solid 2px",
                                                  }}
                                                  onClick={this.deleteEmailScreenshotDoc.bind(
                                                    this
                                                  )}
                                                />
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex align-items-center justify-content-between">
                  <div className="col-sm-12 mt-4 text-center">
                    <>
                      <Button
                        type="button"
                        variant="contained"
                        disabled={this.state.twilioNumber?.verificationStatus?.toLowerCase() === "pending"}
                        style={{
                          background: "#37517e",
                          color: "white",
                          marginRight: "1rem",
                          cursor:
                            this.state.twilioNumber?.verificationStatus?.toLowerCase() === "pending"
                              ? "not-allowed"
                              : "pointer",
                          padding: "2px 10px",
                          textTransform: "capitalize",
                        }}
                        startIcon={
                          <i
                            class="fa fa-paper-plane"
                            style={{ fontSize: "small" }}
                            aria-hidden="true"
                          ></i>
                        }
                        onClick={this.submitCampaignInfoInBackend.bind(this)}
                      >
                        Submit
                      </Button>
                    </>
                    <SaveButton id="saveButton" type="submit">
                      {" "}
                      Save{" "}
                    </SaveButton>
                    <CancelIconButton
                      onClick={(e) => this.handleUseCaseClose()}
                    />
                  </div>
                </div>
              </ValidatorForm>
              {this.showEmailDocument()}
              {this.showKeywordDocument()}
            </>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default UsecaseDialog;
